/* eslint-disable */
// Generated by scripts/sync-aws-exports.mjs from the deployed yf-credit-note-stack
// in account 395949492211. Do not edit by hand - re-run the script.

const awsmobile = {
    "aws_project_region": "ap-southeast-2",
    "aws_cognito_identity_pool_id": "ap-southeast-2:d2d3b7b2-2748-407d-9548-46fb17fbfb1e",
    "aws_cognito_region": "ap-southeast-2",
    "aws_user_pools_id": "ap-southeast-2_qnjk04ohB",
    "aws_user_pools_web_client_id": "7o0osv2shfu1fm1inml1m0as0c",
    "oauth": {
        "domain": "creditnote25652a02-staging.auth.ap-southeast-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://creditnote.stage.youfoodz.com.au/",
        "redirectSignOut": "https://creditnote.stage.youfoodz.com.au/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://mz2q3rwlsbggtlzez6drqsgvkm.appsync-api.ap-southeast-2.amazonaws.com/graphql",
    "aws_appsync_region": "ap-southeast-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": null,
    "aws_user_files_s3_bucket": "yf-credit-note-stack-lineitemuploadsbucket1603aa4f-yhfq0eoyqvtm",
    "aws_user_files_s3_bucket_region": "ap-southeast-2"
};

export default awsmobile;
